"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEmptyRowValuesBySchema = exports.getRowValueIfExists = exports.getSubFieldStyle = exports.getMainTableFieldStyle = void 0;
var getMainTableFieldStyle = function (schema, columnIndex) { var _a; return (_a = schema.fields[columnIndex]) === null || _a === void 0 ? void 0 : _a.styles; };
exports.getMainTableFieldStyle = getMainTableFieldStyle;
var getSubFieldStyle = function (schema, columnIndex, columnRowIndex) { var _a, _b; return (_b = (_a = schema.fields[columnIndex]) === null || _a === void 0 ? void 0 : _a.subFields[columnRowIndex]) === null || _b === void 0 ? void 0 : _b.styles; };
exports.getSubFieldStyle = getSubFieldStyle;
var getRowValueIfExists = function (rows, rowIndex, columnIndex, columnRowIndex) { var _a, _b, _c; return ((_c = (_b = (_a = rows[rowIndex]) === null || _a === void 0 ? void 0 : _a[columnIndex]) === null || _b === void 0 ? void 0 : _b[columnRowIndex]) === null || _c === void 0 ? void 0 : _c.value) || ''; };
exports.getRowValueIfExists = getRowValueIfExists;
/**
 * Makes sure that table rows follows schema. If columns missing from rows initilize with empty values.
 */
var generateEmptyRowValuesBySchema = function (schema, rows) {
    return rows.map(function (row, rowIndex) {
        var currentTableRow = [];
        for (var columnIndex = 0; columnIndex < schema.fields.length; columnIndex++) {
            var mainTableField = schema.fields[columnIndex];
            var tableCells = [];
            var subFields = mainTableField.subFields;
            for (var columnRowIndex = 0; columnRowIndex < subFields.length; columnRowIndex++) {
                tableCells.push({ value: getRowValueIfExists(rows, rowIndex, columnIndex, columnRowIndex) });
            }
            currentTableRow.push(tableCells);
        }
        return currentTableRow;
    });
};
exports.generateEmptyRowValuesBySchema = generateEmptyRowValuesBySchema;
//# sourceMappingURL=tableSelectors.js.map